import { SearchFilterMeta } from 'controllers/SearchController/types';
import { useMemo } from 'react';
import getSuggestionsFromFilters from '../helpers/getSuggestionsFromFilters';

export const useSuggestionsFromFilters = ({
    samplesTotal,
    filterInstrumentsMeta,
    filterGenresMeta,
    filterSfxsMeta,
    filterTagsMeta,
}: {
    samplesTotal?: number;
    filterInstrumentsMeta?: SearchFilterMeta;
    filterGenresMeta?: SearchFilterMeta;
    filterSfxsMeta?: SearchFilterMeta;
    filterTagsMeta?: SearchFilterMeta;
}) => {
    const suggestionsFromFilters = useMemo(() => {
        return samplesTotal
            ? getSuggestionsFromFilters({
                  total: samplesTotal,
                  instruments: filterInstrumentsMeta,
                  genres: filterGenresMeta,
                  sfxs: filterSfxsMeta,
                  tags: filterTagsMeta,
              })
            : [];
    }, [
        samplesTotal,
        filterInstrumentsMeta,
        filterGenresMeta,
        filterSfxsMeta,
        filterTagsMeta,
    ]);

    return suggestionsFromFilters;
};
